module.exports = __webpack_public_path__ + "img-successfuldeployment.dfe850381d6be09cc62c37b571b3c6bb.hashedasset.svg";